import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when the user views the Account Integrations settings page',
  name: 'integrations_page_viewed',
  params: [],
};

export default META;
